export default "__VITE_ASSET__BS2Zigwl__"